import React from 'react';
import { XCircle } from 'lucide-react';
export function WhyItFails() {
  const failures = [{
    title: '"Sleep Hygiene"',
    reason: "Fails at 3AM because you're already awake."
  }, {
    title: 'Random Supplements',
    reason: "Fail because there's no order or feedback—you never know what helped."
  }, {
    title: 'Scrolling',
    reason: 'Fails because it trains your brain: bed = light = information = alertness.'
  }, {
    title: 'Thinking Yourself Calm',
    reason: 'Fails when your body is activated (heat, bladder, cortisol).'
  }];
  return <section className="py-24 px-4 bg-[#f5f0e8]" data-id="element-160">
      <div className="max-w-4xl mx-auto" data-id="element-161">
        <h2 className="text-3xl md:text-4xl font-serif text-[#1e2a38] text-center mb-12" data-id="element-162">
          Why old solutions fail <br data-id="element-163" />
          <span className="text-xl md:text-2xl italic font-normal text-gray-600" data-id="element-164">
            (and why you're not crazy)
          </span>
        </h2>

        <div className="space-y-4" data-id="element-165">
          {failures.map((item, index) => <div key={index} className="flex items-start gap-4 bg-white p-6 rounded-lg shadow-sm border-l-4 border-red-400" data-id="element-166">
              <XCircle className="text-red-400 shrink-0 mt-1" size={24} data-id="element-167" />
              <div data-id="element-168">
                <h3 className="text-lg font-bold text-[#1e2a38]" data-id="element-169">
                  {item.title}
                </h3>
                <p className="text-gray-600" data-id="element-170">{item.reason}</p>
              </div>
            </div>)}
        </div>

        <div className="mt-12 text-center" data-id="element-171">
          <p className="text-xl font-serif text-[#1e2a38]" data-id="element-172">
            You don't need motivation. <br data-id="element-173" />
            You need a bedside system that works while you're half-asleep.
          </p>
        </div>
      </div>
    </section>;
}